const MIN_STROKE_LENGTH = 12;

const strokeLength = (points) =>
  points
    .slice(1)
    .reduce(
      (length, point, index) =>
        length + Math.hypot(point.x - points[index].x, point.y - points[index].y),
      0
    );

/**
 * A single tap leaves a dot on the pad; only a stroke the finger actually moved along counts
 * as a signature.
 *
 * @param {Array<Array<{ x: number, y: number }>>} strokes - `SignaturePad#toData()`
 */
export const hasRealStroke = (strokes) =>
  Array.isArray(strokes) &&
  strokes.some((points) => Array.isArray(points) && strokeLength(points) >= MIN_STROKE_LENGTH);
